export default "__VITE_ASSET__e481c2ea__"